import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../assets/css/GameOverModal.css";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";
import "../assets/css/colors.css"


const GameOverModal = ({ isVisible, onPlayAgain, onExit }) => {

    const { darkMode } = useDarkMode();

    const navigate = useNavigate();
    const { selLanguage, toggleLanguage, isLoading } = useLanguage();

    // Notify that game is finished when modal becomes visible
    useEffect(() => {
        if (isVisible) {
            window.dispatchEvent(new CustomEvent('gameFinished'));
        }
    }, [isVisible]);
    return (
        <AnimatePresence>
            {isVisible && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        className="game-over-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    />

                    {/* Modal */}
                    <motion.div
                        className="game-over-modal"
                        initial={{ opacity: 0, scale: 0.7, y: -50 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.7, y: -50 }}
                        style={{
                            background: darkMode ? "linear-gradient(145deg, #1f2937 0%, #374151 100%);" : "var(--lightModeModal)"
                        }}
                        transition={{
                            type: "spring",
                            damping: 25,
                            stiffness: 300,
                            duration: 0.4
                        }}
                    >

                        {/* Title */}
                        <h1 className="game-over-title">
                            GAME OVER
                        </h1>

                        {/* Message */}
                        <p
                            className="game-over-message"
                            style={{
                                color: darkMode ? "#fff" : "#0f0f0fff"
                            }}
                        >
                            {selLanguage ? "Έχασες όλες τις ζωές σου!" : "You have lost all your lives!"}
                            <br />
                            <span
                                className="no-xp-warning"
                                style={{
                                    color: darkMode ? "#fff" : "#0f0f0fff"
                                }}
                            >
                                {selLanguage ? "Δεν μπορείς να πάρεις XP από αυτή την προσπάθεια!" : "You cannot earn XP from this attempt!"}
                            </span>
                        </p>

                        {/* Buttons */}
                        <div className="game-over-buttons">
                            <motion.button
                                className="game-over-btn play-again-btn"
                                whileHover={{ scale: 1.05, }}
                                whileTap={{ scale: 0.95 }}
                                onClick={onPlayAgain}
                            >

                                {selLanguage ? "Παίξε Ξανά" : "Play Again"}
                            </motion.button>

                            <motion.button
                                className="game-over-btn exit-btn"
                                whileHover={{ scale: 1.05, }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => { navigate("/admin/index") }}
                            >
                                {selLanguage ? "Έξοδος" : "Exit"}
                            </motion.button>
                        </div>

                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default GameOverModal;